<template>
  <div class="child-route-wrapper">
    <h1 class="registration-form-title">
      How will you use Kingpin?
    </h1>
    <div
      v-for="(userType, index) in userTypeData"
      :key="index"
      class="user-type-item"
      @click="onUserTypeSelect(userType)"
    >
      <component :is="userType.icon" />
      <div class="user-type-text">
        <p class="user-type-title">
          {{ userType.title }}
        </p>
        <p class="user-type-description">
          {{ userType.description }}
        </p>
      </div>
      <chevron-right-icon class="chevron-icon" />
    </div>
  </div>
</template>
<script>
import { useFormFields } from '@/views/apps/authentication-v2/useFormFields'
import { AUTH_REGISTER_V2_CHILDREN } from '@/router/routes/utils'
import BrandIcon from '@/@core/assets/svg-components/BrandIcon.vue'
import DistributorIcon from '@/@core/assets/svg-components/DistributorIcon.vue'
import RetailerIcon from '@/@core/assets/svg-components/RetailerIcon.vue'
import { ChevronRightIcon } from 'vue-feather-icons'
import { SET_FORM_DATA } from '@/store/modules/register.module'
import { constants as utilConstants } from '@kingpin-global/kingpin-utils-frontend'
import analytics from '@/@core/utils/analytics'
import constants, { FLAG_CONSTANTS } from '@/constants'

export default {
  name: 'ChooseUserType',
  components: {
    ChevronRightIcon,
    BrandIcon,
    DistributorIcon,
    RetailerIcon,
  },
  data() {
    return {
      userTypeData: [
        {
          icon: BrandIcon,
          title: "I'm a Brand",
          typeLabel: 'Brand',
          type: utilConstants.ROLES.BRAND,
          description: 'Upload, manage and sell your own products on the platform',
        },
        {
          icon: DistributorIcon,
          title: "I'm a Distributor",
          typeLabel: 'Distributor',
          type: utilConstants.ROLES.BRAND,
          description: 'Find brands and manage wholesale orders for your retail partners',
        },
        {
          icon: RetailerIcon,
          title: "I'm a Retailer",
          typeLabel: 'Retailer',
          type: utilConstants.ROLES.RETAILER,
          description: 'Discover brands and place wholesale orders for your retail business',
        },
      ],
      selectedUserType: null,
    }
  },
  computed: {
    isUploadBannerLogoEnabled() {
      return this.$store.state.flags[FLAG_CONSTANTS.REGISTRATION_FLOW_V2]
    },
  },
  mounted() {
    analytics.track(constants.TRACKS.ACTIONS.REGISTER_V2.USER_TYPE_VIEW)
  },
  setup() {
    const {
      companyName,
      companyRole,
    } = useFormFields()
    return {
      companyName,
      companyRole,
    }
  },
  methods: {
    onUserTypeSelect(newType) {
      analytics.track(constants.TRACKS.ACTIONS.REGISTER_V2.USER_TYPE_SELECT, {
        formData: {
          selectedAccountType: newType.typeLabel,
        },
      })
      this.selectedUserType = newType
      this.$store.commit(SET_FORM_DATA, { userType: newType.type })
      if (this.isUploadBannerLogoEnabled) {
        this.$router.push({ name: AUTH_REGISTER_V2_CHILDREN.UPLOAD_LOGO })
      } else {
        this.$router.push({ name: AUTH_REGISTER_V2_CHILDREN.SET_LAUNCH_DATE })
      }
    },
  },
}
</script>
<style lang="scss">
@import '../common-styles.scss';

.user-type-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  border: 1.5px solid #C9CDD2;
  max-width: 528px;
  margin-bottom: 16px;
  cursor: pointer;

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  }
}

.chevron-icon {
  width: 24px;
  height: 24px;
}
.user-type-title {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #272A31;
  margin: 0;
}
.user-type-description {
  font-size: 16px;
  line-height: 24px;
  color: #61646B;
  margin: 0;
}
</style>
